require("../../js/bootstrap");
import { createApp } from "vue";
import App from "./App.vue";

import router from './app_test_routes'
import Notifications from '@kyvg/vue3-notification'

const VueScrollTo = require('vue-scrollto')

const app = createApp(App)

app.use(VueScrollTo)
app.use(Notifications)
app.use(router)

app.mount("#app");

